


















import Vue from 'vue';
import SideNav from '../components/SideNav.vue';

export default Vue.extend({
  components: {
    SideNav,
  },
  data() {
    return {
    };
  },
  computed: {
    sidebarActive() {
      return this.$store.state.sidebarActive;
    },
    overlayActive() {
      return this.$store.state.overlayActive;
    },
  },
  methods: {
    controlSidebar() {
      this.$store.commit('updateSidebarActive', !this.sidebarActive);
      this.$store.commit('updateOverlayActive', !this.overlayActive);
    },
  },
});
